import { Navigate, Outlet } from "react-router-dom";

interface IProps {
    children?: React.ReactNode; 
}

const ProtectedRoute: React.FC<IProps> = ({ children }) => {
    const isAuthenticated = ['22027315802','29337904837'].includes((sessionStorage.getItem("cpf") || ''));

    if (!isAuthenticated) {
        return <Navigate to="/" />;
    }

    return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute;
